
import React, { useEffect, useRef, useState, forwardRef } from "react";
import PageError from "./PageError.js";
import { MDBBtn, MDBDatatable, MDBIcon, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle } from "mdb-react-ui-kit";
import { getPlans, getRevenueReports, getTransactionByTIds } from "../services/apiServices.js";
import DatePicker from 'react-datepicker';
import calImg from "./../components/images/calendar.svg";
import ExcelExportButton from "../components/exportToExcel.js";
import Loader from "../components/Loader.js";
import moment from 'moment-timezone';
import { format } from 'date-fns';
import { formatDate } from '../utils/DateFormat';
import { LineReportChart } from "../components/renewalGraph.js";
import { BasePlanName } from "../utils/BasePlanName.js";
import { useAnalytics } from "../hooks/useAnalytics.js";

function NewRevenueReport() {
    const { trackButtonClick } = useAnalytics();
    const [DayFilter1, setDayFilter1] = useState("1");
    console.log("DayFilter1", DayFilter1)
    const [breakdownApplied, setBreakdownApplied] = useState(false);
    const [memberData, setmemberData] = useState([])
    const [apiError, setApiError] = useState(false);
    const [DayFilter, setDayFilter] = useState("4");
    const [rangeFilter, setRangeFilter] = useState("");
    const [loading, setLoading] = useState(false)
    const [graphCheck, setGraphCheck] = useState(false)
    const [basicData, setBasicData] = useState({
        columns: [
            { label: 'Date', field: 'date' },
            { label: 'New', field: 'new' },
            { label: 'Renew', field: 'renew' },
            { label: 'Grand Total', field: 'grandtotal' },
        ],

        rows: [],
    });
    const [basicData2, setBasicData2] = useState({
        columns: [
            { label: 'Date', field: 'date' },
            { label: 'Member Name', field: 'memberName' },
            { label: 'Plan', field: 'plan' },
            { label: 'Addon', field: 'addon' },
            { label: 'Total Amount', field: 'totalAmount' },
            { label: 'Transaction Type', field: 'transactionType' },
        ],
        rows: [],
    })
    const [card, setCard] = useState({
        new: 0,
        renew: 0,

    })
    const searchRef = useRef();
    const [customdate, setcustomdate] = useState(DayFilter === "6");
    const [customRange, setCustomRange] = useState(rangeFilter === "5")
    const today = new Date();
    const currentTime = new Date();
    const startOfToday = new Date(currentTime);
    startOfToday.setHours(0, 0, 0, 0);

    const endOfToday = new Date(currentTime);
    endOfToday.setHours(23, 59, 59, 999);

    const yesterday = new Date(currentTime);
    yesterday.setDate(currentTime.getDate() - 1);
    const startOfYesterday = new Date(yesterday);
    startOfYesterday.setHours(0, 0, 0, 0);

    const endOfYesterday = new Date(yesterday);
    endOfYesterday.setHours(23, 59, 59, 999);

    const startOfWeek = new Date(currentTime);
    startOfWeek.setDate(currentTime.getDate() - currentTime.getDay());
    startOfWeek.setHours(12, 0, 0, 0);
    const endOfWeek = new Date(currentTime);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    endOfWeek.setHours(12, 0, 0, 0);

    const startOfMonth = new Date(currentTime);
    startOfMonth.setDate(1);
    startOfMonth.setHours(0, 0, 0, 0);

    const endOfMonth = new Date(currentTime);

    const startOfYear = new Date(currentTime);
    startOfYear.setMonth(0, 1);
    startOfYear.setHours(0, 0, 0, 0);

    const endOfYear = new Date(currentTime);
    endOfYear.setMonth(11, 31);
    endOfYear.setHours(23, 59, 59, 999);
    today.setHours(23, 59, 0, 0);
    const [dateRange, setDateRange] = useState([startOfMonth, endOfMonth]);
    const [startDate, endDate] = dateRange;
    const [applyFilterClicked, setApplyFilterClicked] = useState(false)
    const [resetFilterClicked, setResetFilterClicked] = useState(false)
    const [mfilter, setMfilter] = useState({
        tidName: "",
        Ttype: "",
    })
    const [selectedRowData, setSelectedRowData] = useState(null);

    const [range, setRange] = useState({
        from: 0,
        to: 0
    })
    const [openTogle, setOpenTogle] = useState(false)
    const [memberName, setMemberName] = useState("")

    const [plans, setPlans] = useState("");
    console.log("plansssssssssssssssss", plans)


    useEffect(() => {
        async function fetchPlans() {
            try {
                const loggedUser = JSON.parse(localStorage.getItem("loggedUserInfo"));
                const planResponse = await getPlans(loggedUser.gymid);

                if (!planResponse || planResponse === "false") {
                    setApiError(true);
                } else {
                    const plans = await planResponse.json();
                    if (plans) {
                        setPlans(plans);
                    }
                }
            } catch (error) {
                console.error("Error fetching plans:", error);
                setApiError(true);
            }
        }

        fetchPlans();
    }, []);




    const CalenderInput = forwardRef(({ value, onClick }, ref) => (
        <>
            <span className="gym-input forminput h-40">
                {value === "" ? "Custom Range" : value}
                &nbsp;
                <img
                    src={calImg}
                    onClick={onClick}
                    ref={ref}
                    alt="custom Range"
                    title="Select Custom Range"
                />
            </span>
        </>
    ));

    const getDates = (obj) => {
        setDateRange(obj);
    };




    /**
    * handleApplyAndToggle function is used for applying filters .
    * created by vamshi
    * @function
    * 
    * @description
    * This handleApplyAndToggle function has been create on [30-7-2024] used to set the filters.
    */
    const handleApplyAndToggle = () => {
        const sDate = DayFilter === "1" ? startOfToday : (DayFilter === "2" ? startOfYesterday : (DayFilter === "3" ? startOfWeek : (DayFilter === "4" ? startOfMonth : (DayFilter === "5" ? startOfYear : (DayFilter === "6" ? startDate : null)))))
        const eDate = DayFilter === "1" ? endOfToday : (DayFilter === "2" ? endOfYesterday : (DayFilter === "3" ? endOfWeek : (DayFilter === "4" ? endOfMonth : (DayFilter === "5" ? endOfYear : (DayFilter === "6" ? endDate : null)))))
        if (sDate !== null && eDate !== null) {
            setDateRange([sDate, eDate])
        } else {
            setDateRange([])
        }

        const updatedColumns = [
            { label: 'Date', field: 'date' },
        ];

        if (mfilter.Ttype === "New" || mfilter.Ttype === "") {
            updatedColumns.push({ label: 'New', field: 'new' });
        }
        if (mfilter.Ttype === "Renew" || mfilter.Ttype === "") {
            updatedColumns.push({ label: 'Renew', field: 'renew' });
        }

        if (mfilter.Ttype === "") {
            updatedColumns.push({ label: 'Grand Total', field: 'grandtotal' });
        }

        setBasicData(prevData => ({
            ...prevData,
            columns: updatedColumns,
        }));

        setBreakdownApplied(true);
        setApplyFilterClicked(true)
    }


    /**
    * handleResetAndToggle function is used to clear filters .
    * created by vamshi
    * @function
    * 
    * @description
    * This handleResetAndToggle function has been create on [30-7-2024] used for reset the filters .
    */
    const handleResetAndToggle = () => {

        setDayFilter("4")
        setDateRange([startOfMonth, endOfMonth])
        setMfilter({
            tidName: "",
            Ttype: "",
        })
        setDayFilter1("1")
        setBreakdownApplied(false);
        setResetFilterClicked(true)
        setCustomRange(false)
        setRange({
            from: 0,
            to: 0
        })
        setRangeFilter("")
        setResetFilterClicked(true)
        // Reset grouped data
        setBasicData({
            columns: [
                { label: 'Date', field: 'date' },
                { label: 'New', field: 'new' },
                { label: 'Renew', field: 'renew' },
                { label: 'Grand Total', field: 'grandtotal' },
            ],
            rows: [],
        });

    }
    let filter = {}

    /**
* fetchData function is used for fetch revenue Data .
* created by vamshi
* @function
* 
* @description
* This fetchData function has been create on [30-7-2024] used to set the filters.
*/
    async function fetchData() {
        setLoading(true)
        let startOfDate = startDate
        let endOfDate = endDate
        let Dateobj = {}
        filter.name = mfilter.tidName
        filter.Ttype = mfilter.Ttype

        if ((startOfDate && endOfDate)) {
            const startDatef = new Date(startOfDate)
            startDatef.setHours(0, 0, 0, 0)
            const utcstartDate = startDatef.toISOString();
            let lastoftheday = new Date(endOfDate);
            lastoftheday.setHours(23, 59, 59, 999);
            const utcEndDate = lastoftheday.toISOString();
            Dateobj = {
                startDate: utcstartDate,
                endDate: utcEndDate,

            }
        }
        filter.dateobj = Dateobj
        filter.breaktype = DayFilter1
        const response = await getRevenueReports(
            JSON.parse(localStorage.getItem("loggedUserInfo")).gymid, filter
        );

        // console.log(response);
        if (!response) {
            return;
        }
        if (response === "false") {
            setApiError(true)
            return;
        }

        const record = await response.json();
        if (!record) {
            return;
        }
        console.log(record, '8888888888888888');
        const sortedRecord = record.sort((a, b) => new Date(b._id) - new Date(a._id));

        console.log(sortedRecord);


        setLoading(true)
        setmemberData(record);

        setApplyFilterClicked(false)
        setResetFilterClicked(false)

    }

    useEffect(() => {
        if (localStorage.getItem("loggedUserInfo")) {
            fetchData();
        }

    }, [applyFilterClicked, resetFilterClicked])

    useEffect(() => {
        setcustomdate(DayFilter === "6" ? true : false);
    }, [DayFilter]);

    useEffect(() => {
        setCustomRange(rangeFilter === "5" ? true : false);
    }, [rangeFilter]);


    /**
    * generateInvoice function is used for get the finnal Amount.
    * created by vamshi
    * @function
    * 
    * @description
    * This generateInvoice function has been create on [26-4-2025].
    */
    const generateInvoice = (price, discount = 0, tax = []) => {
        if (!price) return 0;
        const hasIncluded = tax.length > 0 ? tax.some(taxItem => taxItem.TaxCheck === "Included") : true;
        let planPrice = hasIncluded ? parseFloat(price / (1 + ((tax && tax.length > 0) ? (tax.reduce((acc, obj) => acc + (obj.percentage ? (parseFloat(obj.percentage) / 100) : 0), 0)) : 0))).toFixed(2) : price
        const totaltaxpercentage = (tax && tax.length > 0)
            ? tax.reduce((acc, obj) => acc + (obj.percentage ? parseFloat(obj.percentage) : 0), 0)
            : 0;

        const discountedPrice = parseFloat(planPrice) - parseFloat(discount);

        const totalTaxAmount = parseFloat(discountedPrice) * (totaltaxpercentage / 100);
        const finalPrice = discountedPrice + parseFloat(totalTaxAmount);

        if (isNaN(finalPrice)) {
            return 0;
        }
        return Math.round(finalPrice);
    };


    const [selectedData, setSelectedData] = useState([])
    console.log(selectedData);

    /**
   * handleRowClick function is used for get the Row data which is clicked.
   * created by vamshi
   * @function
   * 
   * @description
   * This handleRowClick function has been create on [26-4-2025].
   */
    const handleRowClick = (data, columnField) => {
        console.log(data, columnField);
        setSelectedRowData(data)
        let ids = [];

        if (columnField === "new" && data.new && data.new.transinfo) {
            ids = data.new.transinfo.map(item => item.id);
        } else if (columnField === "renew" && data.renew && data.renew.transinfo) {
            ids = data.renew.transinfo.map(item => item.id);
        } else {
            const newIds = data.new && data.new.transinfo ? data.new.transinfo.map(item => item.id) : [];
            const renewIds = data.renew && data.renew.transinfo ? data.renew.transinfo.map(item => item.id) : [];
            ids = [...newIds, ...renewIds];
        }

        console.log("Ids to send:", ids);

        fetchTransData(ids);
    };

    useEffect(() => {
        const popupRow = [];

        if (memberData && memberData.length > 0) {

            memberData.forEach(item => {
                // let formattedDate;
                // if (DayFilter1 == "1") {
                //     try {
                //         if (item.datelabel) {
                //             formattedDate = formatDate(item.datelabel);
                //         } else if (item.date) {
                //             formattedDate = formatDate(item.date);
                //         } else if (item.createdAt) {
                //             formattedDate = formatDate(item.createdAt);
                //         } else {
                //             formattedDate = formatDate(item._id);
                //         }
                //     } catch (error) {
                //         console.error('Date formatting error:', error);
                //         formattedDate = item.datelabel || item._id || 'No Date';
                //     }
                // }
                // else {
                //     formattedDate = item.datelabel;
                // }
                const rowData = {
                    date: item.datelabel,
                    new: <span
                        className="button-link link-color"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleRowClick(item, "new");
                        }}
                    >
                        {/* {item.new?.amount} */}
                        {"₹" + (item.new?.amount || 0).toLocaleString('en-IN')}
                    </span>,
                    renew: <span
                        className="button-link link-color"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleRowClick(item, "renew");
                        }}
                    >
                        {/* {item?.renew?.amount} */}
                        {"₹" + (item?.renew?.amount || 0).toLocaleString('en-IN')}
                    </span>,
                    grandtotal: <span
                        className="button-link link-color"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleRowClick(item, "total");
                        }}
                    >
                        {/* {(item.new?.amount) + (item.renew?.amount)} */}
                        {"₹" + ((item.new?.amount) + (item.renew?.amount) || 0).toLocaleString('en-IN')}
                    </span>,
                    originalItem: item
                };
                popupRow.push(rowData);

            });

        }

        setBasicData(prevData => ({
            ...prevData,
            rows: popupRow
        }));


        calculateNewAndRenewAmount();
        setLoading(false);
    }, [memberData, breakdownApplied]);



    const calculateNewAndRenewAmount = () => {
        let totalNewAmount = 0;
        let totalRenewAmount = 0;

        memberData.forEach(item => {
            if (item.new && item.new.amount) {
                totalNewAmount += item.new.amount;
            }
            if (item.renew && item.renew.amount) {
                totalRenewAmount += item.renew.amount;
            }
        });

        // you can now set state or console log
        setCard({
            new: totalNewAmount,
            renew: totalRenewAmount
        });

        console.log(`Total New Revenue: ${totalNewAmount}`);
        console.log(`Total Renew Revenue: ${totalRenewAmount}`);


    };



    const handleReload = () => {
        window.location.reload();
    }

    const filterAmount = (amount) => {
        let numericValue = 0
        if (typeof amount === 'string') {
            const cleanedValue = amount.replace(/[₹,]/g, '');
            numericValue = Number(cleanedValue);
        }
        return numericValue;
    }
    console.log(basicData2);

    const downloaddata = (type) => {
        let obj;

        if (type === 'grouped') {
            console.log("Exporting Grouped Data", basicData);

            const cleanedRows = basicData.rows && basicData.rows.length > 0 && basicData.rows.map(row => [
                row.date,
                cleanNumericValue(row.new),
                cleanNumericValue(row.renew),
                cleanNumericValue(row.grandtotal),
            ]);

            obj = {
                columns: ['Date', 'New', 'Renew', 'Grand Total'],
                rows: cleanedRows,
            };

            ExcelExportButton(obj, "Grouped Revenue Report");
            trackButtonClick("newRevenue", "Export_Revenue_Report", "staff", {});
        } else if (type === 'basic') {
            const cleanedData = basicData2.rows.map(row => {
                return row.map(cell => {
                    console.log(cell);

                    if (React.isValidElement(cell)) {
                        const value = cell.props.children;
                        if (typeof value === 'string') {

                            // const cleanedValue = value.replace(/[₹,]/g, '');
                            // const numericValue = Number(cleanedValue);
                            if (cell.props.className == 'trans-date') {
                                return value
                            } else {
                                const numericValue = filterAmount(value)
                                if (!isNaN(numericValue)) {
                                    return {
                                        ...cell,
                                        props: {
                                            ...cell.props,
                                            children: numericValue
                                        }
                                    };
                                }
                            }

                        }
                    }
                    if (typeof cell === 'string' && (cell.includes('₹'))) {
                        const numericValue = filterAmount(cell);
                        return !isNaN(numericValue) ? numericValue : cell;
                    }
                    return cell;
                });
            });

            console.log(cleanedData);
            const list = {
                columns: basicData2.columns,
                rows: cleanedData
            }

            ExcelExportButton(list, "Transaction Report");
            trackButtonClick("newRevenue", "Export_Revenue_Report", "staff", {});
        } else {
            console.warn("Invalid export type or no data available.");
        }
    };

    console.log(basicData);

    // Helper function to clean currency values
    const cleanNumericValue = (value) => {
        if (React.isValidElement(value)) {
            value = value.props.children;
        }

        if (typeof value === 'string') {
            const cleanedValue = value.replace(/[₹$,]/g, '');
            const numericValue = Number(cleanedValue);
            return !isNaN(numericValue) ? numericValue : value;
        }

        return value;
    };


    console.log(selectedRowData);
    // console.log(selectedTrans);
    useEffect(() => {
        const popupRow = [];

        if (selectedData && selectedData.length > 0) {
            selectedData.forEach((selectedRowData) => {
                const rarray = [];
                const tax = selectedRowData.payment.taxamounts || [];
                const discountValue = selectedRowData.payment.discount ? selectedRowData.payment.discount.amount : 0;

                rarray.push(selectedRowData.token || "--");
                rarray.push(selectedRowData.members?.fname ? selectedRowData.members.fname + " " + selectedRowData.members.lname : "");



                rarray.push(
                    selectedRowData.plan && selectedRowData.plan.length > 0 && selectedRowData.plan[0].name
                        ? selectedRowData.plan[0].name
                        : selectedRowData.subplan && selectedRowData.subplan.length > 0
                            ? `${BasePlanName(plans, selectedRowData.subplan[0].baseplan)} - ${selectedRowData.subplan[0].name}`
                            : selectedRowData.addons && selectedRowData.addons.length > 0 && selectedRowData.addons[0].name
                                ? selectedRowData.addons[0].name
                                : ""
                );



                rarray.push(
                    <span className="trans-date">
                        {formatDate(selectedRowData.createdAt).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })}
                    </span>
                );

                rarray.push("₹" + (selectedRowData.payment.itemprice || 0).toLocaleString('en-IN'));

                rarray.push("₹" + (discountValue || 0).toLocaleString('en-IN'));
                rarray.push("₹" + (selectedRowData?.payment?.balance ? selectedRowData?.payment?.balance : 0))
                rarray.push(
                    "₹" +
                    (generateInvoice(
                        selectedRowData.payment.itemprice || 0,
                        discountValue || 0,
                        tax || []
                    )).toLocaleString('en-IN')
                );

                popupRow.push(rarray);
            });
        }

        setBasicData2({
            columns: ['Order Id', 'Member Name', 'Membership', 'Date', 'Price', 'Discount', "Due Amount", 'Total'],
            rows: popupRow
        });

    }, [selectedData]);


    /**
* fetchTransData used for get the selected transaction based on filters
* created by vamshi
* @function
* 
* @description
* This fetchTransData been create on [26-4-2025].
*/
    const fetchTransData = async (transid) => {
        const update = {
            tids: transid
        }
        const transResponse = await getTransactionByTIds(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid, update)
        if (!transResponse) {
            return;
        }
        if (transResponse === "false") {
            setApiError(true)
            return;
        }

        const record = await transResponse.json();
        console.log(record);

        if (!record) {
            return;
        }
        setOpenTogle(true)
        setSelectedData(record)
    }

    const [breakdownOptions, setBreakdownOptions] = useState([
        { label: "Day", value: "1" },
        { label: "Week", value: "2" },
        { label: "Month", value: "3" },
        { label: "Year", value: "4" },
    ]);

    useEffect(() => {
        let options = [];

        if (DayFilter === "1" || DayFilter === "2" || DayFilter === "3") {

            options = [{ label: "Day", value: "1" }];
            setDayFilter1("1");
        } else if (DayFilter === "4") {

            options = [
                { label: "Day", value: "1" },
                { label: "Week", value: "2" },
            ];
            setDayFilter1("1");
        } else if (DayFilter === "5") {

            options = [
                { label: "Day", value: "1" },
                { label: "Week", value: "2" },
                { label: "Month", value: "3" },
            ];
            setDayFilter1("1");
        } else {

            options = [
                { label: "Day", value: "1" },
                { label: "Week", value: "2" },
                { label: "Month", value: "3" },
                { label: "Year", value: "4" },
            ];
            setDayFilter1("1");
        }

        setBreakdownOptions(options);
    }, [DayFilter]);
    console.log(basicData, 'basicData');

    return (
        <>


            {apiError ? <PageError handleReload={handleReload} /> :
                <div className="mt-4">
                    <div className="d-flex align-items-center TrainerSummeryCustomHead">
                        <div className="d-flex">

                            <div class="filters_Count bg-success bg-opacity-10"><p class="text-center mb-1 fw-600">New Revenue</p>₹{(card.new).toLocaleString('en-IN')} </div>
                            <div class="filters_Count bg-danger bg-opacity-10"><p class="text-center mb-1 fw-600">Renew Revenue</p>₹{(card.renew).toLocaleString('en-IN')}</div>

                        </div>
                    </div>

                    <div className=" d-flex flex-wrap w-90 align-items-end">

                        <div className="gym-section w-100-mobile ms-2">
                            <label className="fw-bold">Transaction type:</label>
                            <div>
                                <select
                                    name="emailReminder"
                                    id="emailReminder"
                                    className="form-control form-control-sm select-input placeholder-active form-select shadow-1 form-selectMobile"
                                    value={mfilter.Ttype}

                                    onChange={(e) => setMfilter({
                                        ...mfilter,
                                        Ttype: e.target.value
                                    })}
                                >
                                    <option value="">All</option>
                                    <option value="Renew">Renew</option>
                                    <option value="New">New</option>
                                </select>
                            </div>
                        </div>
                        <div className="gym-section w-100-mobile ms-2">
                            <label className="me-2 fw-bold"> Date: </label>
                            <div className="mob-w-100 ">
                                <select
                                    name="shrs"
                                    id="shr"
                                    className="form-control form-control-sm select-input form-select placeholder-active me-3 shadow-1 form-selectMobile"
                                    onChange={(e) => setDayFilter(e.target.value)}
                                    value={DayFilter}
                                >
                                    <option value="7">All</option>
                                    {/* <option value="1">Today</option> */}
                                    <option value="2">Yesterday</option>
                                    <option value="3">This Week</option>
                                    <option value="4">This Month</option>
                                    <option value="5">This Year</option>
                                    <option value="6">Custom</option>

                                </select>
                            </div>
                        </div>

                        <div className="gym-section w-100-mobile ms-2">
                            <label className="me-2 fw-bold"> Breakdown: </label>
                            <div className="mob-w-100 ">
                                <select
                                    name="shrs"
                                    id="shr"
                                    className="form-select form-select-sm placeholder-active active mob-w-100"
                                    onChange={(e) => setDayFilter1(e.target.value)}
                                    value={DayFilter1}
                                >

                                    {breakdownOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {customRange && <div className="gym-section w-100-mobile ms-2">
                            <label className="fw-bold">Custom Range</label>
                            <div className="d-flex align-items-center w-auto">
                                <input type="number" name="" id="" className="form-control w-80px" placeholder="From" value={range.from}
                                    onChange={(e) => setRange({
                                        ...range,
                                        from: e.target.value
                                    })} />

                                <div className="mx-2">-</div>
                                <input type="number" name="" id="" className="form-control w-80px " placeholder="To" value={range.to}
                                    onChange={(e) => setRange({
                                        ...range,
                                        to: e.target.value
                                    })} />
                            </div>
                        </div>}
                        {customdate && <div className="gym-section w-100-mobile ms-3">
                            <span className="customRange align-items-center">
                                <label className="fw-bold">Custom Range</label>
                                <div className="gym-xlarge gym-larg-pos">
                                    <DatePicker
                                        dateFormat={"d/M/yyyy"}
                                        selectsRange={true}

                                        startDate={startDate}
                                        endDate={endDate}
                                        onChange={(update) => {
                                            getDates(update)
                                        }}
                                        isClearable={false}
                                        customInput={<CalenderInput />}
                                    />
                                </div>
                            </span>
                        </div>}
                        <div className="gym-section w-100-mobile ms-3">
                            <div className="filterApplyMobile">
                                <button
                                    type="submit"
                                    className="me-3 btn btn-primary"
                                    onClick={() => handleApplyAndToggle()}
                                >
                                    Apply
                                </button>
                                <button
                                    type="submit"
                                    className="mt-2 btn btn-secondary"
                                    onClick={() => { handleResetAndToggle() }}
                                >
                                    Clear
                                </button>
                                {(localStorage.getItem("loggedUserInfo")) && JSON.parse(localStorage.getItem("loggedUserInfo")).role === "admin" && <button type="submit" className="ms-3 btnheight btn btn-primary"
                                    onClick={(e) => downloaddata(('grouped'))}
                                >
                                    <MDBIcon fas icon="download" className="d-inline me-1" />Export
                                </button>}
                                <MDBBtn className="ms-2" onClick={() => setGraphCheck(!graphCheck)}>{graphCheck ? <span><MDBIcon fas icon="table" className="me-1" />Table </span> : <span ><MDBIcon fas icon="chart-bar" className="me-1" />Graph</span>}</MDBBtn>
                            </div>
                        </div>
                    </div>



                    {!graphCheck && <div className="">
                        {loading ? (
                            <div className="loader-height">
                                <Loader />
                            </div>
                        ) : (
                            <MDBDatatable
                                className="RevinueReportTable"
                                fixedHeader
                                maxHeight='calc(100vh - 223px)'
                                entries={25}
                                paging={true}
                                data={basicData}
                                // onRowClick={(rowData) => handleRowClick(rowData, "")}
                                tbodyProps={{
                                    style: {
                                        cursor: 'pointer'
                                    }
                                }}
                            />
                        )}
                    </div>}
                    {graphCheck && <div className="w-100 border p-4 mb-4 shadow-4 mob-w-100 mob-p-0">
                        {loading ? (<div className="loader-height"> <Loader /></div>) : <>
                            {/* <RenewPredictionChart data={basicData.rows} /> */}
                            <LineReportChart
                                data={basicData.rows}
                                xField="date"
                                reverse={false}
                                datasetsConfig={[
                                    { field: "new", label: "New", color: "#9966FF" },
                                    { field: "renew", label: "Renew", color: "#36A2EB" },
                                    { field: "grandtotal", label: "Grand Total", color: "#FF9F40", borderWidth: 4 }
                                ]}
                            />
                        </>}
                    </div>}

                </div>

            }
            <MDBModal staticBackdrop tabIndex='-1' open={openTogle} onClose={() => setOpenTogle(false)}>
                <MDBModalDialog size="lg">
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>
                                <h6 className="m-0">{memberName} Transaction Details</h6>
                            </MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={() => setOpenTogle(false)}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody >
                            <div className="trainerMemberSummeryDataTable">
                                <MDBDatatable entries={25} data={basicData2} />

                            </div>
                        </MDBModalBody>
                        <MDBModalFooter className="pe-4 pb-3">
                            <MDBBtn className="ms-2" onClick={() => downloaddata(('basic'))}>download</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </>
    )
}



export default NewRevenueReport
